import * as React from 'react';
import { IconProps } from '../types';

const IcNetSale = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#232F3E"
      d="M11.592 14.495c-.51-.137-.968-.389-1.287-.708a.728.728 0 0 0-1.035 0l-.056.056a.737.737 0 0 0-.214.524.737.737 0 0 0 .223.52c.623.604 1.503 1.04 2.415 1.197l.088.015v.692c0 .403.329.731.732.731h.083a.733.733 0 0 0 .732-.731v-.708l.086-.016c1.514-.288 2.417-1.234 2.417-2.53.014-1.76-1.291-2.403-2.429-2.767l-.074-.023V8.374l.13.028c.335.074.634.186.865.325a.732.732 0 0 0 .997-.24l.037-.06a.737.737 0 0 0 .092-.557.737.737 0 0 0-.333-.456c-.467-.283-1.07-.491-1.698-.587l-.09-.014v-.522a.733.733 0 0 0-.732-.732h-.083a.733.733 0 0 0-.732.732v.56l-.085.018c-1.399.282-2.234 1.16-2.234 2.347 0 1.271.735 2.138 2.247 2.65l.072.025v2.64l-.134-.036Zm1.68-2.11.15.065c.593.26.812.552.808 1.079 0 .438-.275.75-.817.928l-.14.046v-2.118Zm-1.703-2.238c-.443-.237-.615-.498-.615-.931 0-.33.212-.574.629-.728l.143-.053v1.795l-.157-.083Z"
    />
    <path
      fill="#232F3E"
      d="M22.743 5.176a.683.683 0 0 0-.756-.065l-1.438.792a9.727 9.727 0 0 0-8.16-4.426c-5.37 0-9.738 4.368-9.738 9.737a1.064 1.064 0 1 0 2.128 0c0-4.196 3.414-7.61 7.61-7.61a7.602 7.602 0 0 1 6.29 3.329l-1.347.741a.683.683 0 0 0 .14 1.255l3.609 1.046a.68.68 0 0 0 .846-.466l1.046-3.61a.683.683 0 0 0-.23-.723ZM21.285 11c-.588 0-1.065.476-1.065 1.064 0 4.195-3.413 7.608-7.608 7.608a7.602 7.602 0 0 1-6.291-3.327l1.347-.742a.683.683 0 0 0-.14-1.255L3.92 13.303a.681.681 0 0 0-.846.466l-1.046 3.609a.683.683 0 0 0 .986.788l1.438-.792a9.727 9.727 0 0 0 8.16 4.427c5.37 0 9.738-4.368 9.738-9.737 0-.588-.477-1.065-1.064-1.065Z"
    />
  </svg>
);

export default IcNetSale;
